import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Rx';
@Injectable()
export class EditorService {
    editorCardObj;
    textInlineData;
    editorPageData;
    editorData: Subject<any> = new Subject();
    editorData$ = this.editorData.asObservable();

    private bookOption = new Subject<string>();
    bookOption$ = this.bookOption.asObservable();

    constructor() { }

    getEditorData(data) {
        this.textInlineData = data;
        this.editorData.next(data);
    }
    callBookEditOpt(option) {
        this.bookOption.next(option);
    }
    getIframeReference() {
        let com: any = document.getElementById('pageContainer');
        if (com) {
            com = com.contentWindow;
            return com;
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/bookShared/bookeditoption/editor.service.ts